export const COMPANY_HEADER_NAME_DETAILS_GAP_PX = 16;
